import ButtonSecondary from "../../shared/Button/ButtonSecondary";
import useTranslate from "../../../core/languages/hooks/useTranslate";
import {useOidcClientContext} from "../../context/OidcClientContext";
import useCustomerContext from "../../../customers/hooks/useCustomerContext";
import UserDropdown from "./UserDropdown";

export default function LoginButton() {
    const t = useTranslate();
    const {client, authenticated, userDisplayName} = useOidcClientContext();
    const { languageCode } = useCustomerContext();

    const handleLogin = () => client.login({
        locale: languageCode,
    });
    const handleLogout = () => client.logout();
    const handleRegister = () => client.register({
        locale: languageCode,
    });

    if (authenticated) {
        return (
            <UserDropdown
                onClick={handleLogout}
                userDisplayName={userDisplayName || t("mainNav.user")}
            />
        );
    }

    return (
        <>
        <ButtonSecondary
            sizeClass="px-2 py-1 sm:px-4"
            onClick={handleLogin}
        >
            {t("mainNav.login")}
        </ButtonSecondary>
        <ButtonSecondary
            sizeClass="px-2 py-1 sm:px-4"
            onClick={handleRegister}
        >
            {t("mainNav.register")}
        </ButtonSecondary>
        </>
    );
}
